export default "__VITE_ASSET__Ct41vAQv__"